import React, { useEffect, useState } from 'react';
import { Menu, Typography } from 'antd';
import TeamsList from './TeamsList';
import WebChatSiderFilter from './WebChatSiderFilter';
import { webChatSidebar } from '../../constants/WebchatConstants';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import {
  clearTeamConversations,
  fetchTeamConversations,
  fetchUserTeams,
  resetSelectedWebChatConversation,
  setSelectedConversationFilter,
} from '../../../../reduxToolkit/inboxSlice';

const { Text } = Typography;

const WebChatMainSider = () => {
  // hooks
  const dispatch = useDispatch();

  // selectors
  const { currentBrand, currentUser } = useSelector((state) => state?.app);
  const { selectedWebChatTeam, userTeams, conversationExcludeList } =
    useSelector((state) => state?.inbox);

  // states
  const [selectedKeys, setSelectedKeys] = useState(['ALCONV']);
  const [openKeys, setOpenKeys] = useState(['Conversations', 'Teams']);

  // handler functions
  const handleMenuClick = (key) => {
    if (selectedKeys[0] === key) return;
    setSelectedKeys((prev) => {
      if (prev[1]) {
        return [key, prev[1]];
      }
      return [key];
    });
    dispatch(setSelectedConversationFilter(key));
    if (selectedWebChatTeam?.team_id) {
      // dispatch(clearConversationExcludeList());
      dispatch(
        fetchTeamConversations({
          brand_id: currentBrand?.brand_id,
          team_id: selectedWebChatTeam?.team_id,
          team_member_id: selectedWebChatTeam?.team_member_id,
          user_id: currentUser?.id,
          filter: key,
          clearExcludeList: true,
        }),
      );
    }
  };

  const handleTeamClick = (team) => {
    if (selectedKeys[1] === team?.team_id) return;
    setSelectedKeys((prev) => [prev[0], team?.team_id]);
    const excludeListString = conversationExcludeList.join(',');
    const params = {
      excludeListString,
      brand_id: currentBrand?.brand_id,
      team_id: team?.team_id,
      team_member_id: team?.team_member_id,
      user_id: currentUser?.id,
      clearExcludeList: true,
    };

    if (selectedKeys[0]) params.filter = selectedKeys[0];
    dispatch(fetchTeamConversations(params));
  };

  // useEffects

  useEffect(() => {
    if (selectedWebChatTeam?.team_id) {
      dispatch(clearTeamConversations());
    }
  }, [selectedKeys[0]]);

  useEffect(() => {
    dispatch(fetchUserTeams({ brand_id: currentBrand?.brand_id }));
  }, [currentBrand]);

  useEffect(() => {
    if (selectedWebChatTeam?.team_id) {
      dispatch(resetSelectedWebChatConversation());
    }
  }, [selectedWebChatTeam]);

  return (
    <div className="w-full">
      <Menu
        mode="inline"
        style={{ border: 'none' }}
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        className="px-2 min-w-[13vw]- w-full override-default-submenu-styles-channels-submenu"
      >
        {webChatSidebar.map((item) => (
          <Menu.SubMenu
            key={item.name}
            className="min-w-[14vw]- w-full ps-0 bg-white"
            title={
              <Text className="text-xs" strong>
                {item.name}
              </Text>
            }
          >
            {item.name === 'Teams' &&
              userTeams?.map((team) => {
                return (
                  <TeamsList
                    key={team.team_id}
                    name={team.team_name}
                    isSelected={selectedKeys[1] === team?.team_id}
                    onClick={handleTeamClick}
                    {...team}
                  />
                );
              })}
            {item.name === 'Conversations' &&
              item.subMenu?.map((subItem) => {
                const isSelected = selectedKeys.includes(subItem.key);
                // console.log({ isSelected, key: subItem.key, selectedKeys });

                return (
                  <WebChatSiderFilter
                    key={subItem.key}
                    Icon={subItem.Icon}
                    name={subItem.name}
                    isSelected={isSelected}
                    onClick={() => handleMenuClick(subItem.key)}
                  />
                );
              })}
          </Menu.SubMenu>
        ))}
      </Menu>
    </div>
  );
};

export default WebChatMainSider;
